const DELETE_ERROR_KEY_BY_CODE: Record<string, string> = {
  WAREHOUSE_NOT_FOUND: 'logical_warehouse.messages.error.warehouse_not_found',
  WAREHOUSE_IN_USE_BY_SHOP:
    'logical_warehouse.messages.error.warehouse_in_use_by_shop',
  WAREHOUSE_HAS_STOCK: 'logical_warehouse.messages.error.warehouse_has_stock',
  WAREHOUSE_HAS_STOCK_TRANSACTIONS:
    'logical_warehouse.messages.error.warehouse_has_stock_transactions',
  WAREHOUSE_HAS_INBOUND_NOTICE:
    'logical_warehouse.messages.error.warehouse_has_inbound_notice',
  WAREHOUSE_HAS_FULFILLMENT_ORDERS:
    'logical_warehouse.messages.error.warehouse_has_fulfillment_orders',
  WAREHOUSE_HAS_ALERTS: 'logical_warehouse.messages.error.warehouse_has_alerts',
  WAREHOUSE_HAS_PUTAWAY_TASKS:
    'logical_warehouse.messages.error.warehouse_has_putaway_tasks',
  WAREHOUSE_HAS_RELATED_DATA:
    'logical_warehouse.messages.error.warehouse_has_related_data',
};

export const LOGICAL_WAREHOUSE_DELETE_FALLBACK_KEY =
  'logical_warehouse.messages.error.failed_to_delete';

export function resolveLogicalWarehouseDeleteErrorKey(error: unknown): string {
  const { status, error: body } = (error ?? {}) as {
    status?: number;
    error?: { errorCode?: string };
  };
  const errorCode = body?.errorCode;
  if (errorCode && DELETE_ERROR_KEY_BY_CODE[errorCode]) {
    return DELETE_ERROR_KEY_BY_CODE[errorCode];
  }
  if (status === 0) {
    return 'logical_warehouse.messages.error.delete_network_error';
  }
  if (status === 401 || status === 403) {
    return 'logical_warehouse.messages.error.delete_no_permission';
  }
  if (status !== undefined && status >= 500) {
    return 'logical_warehouse.messages.error.delete_server_error';
  }
  return LOGICAL_WAREHOUSE_DELETE_FALLBACK_KEY;
}
